import React from 'react';
import classNames from 'classnames';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Icon } from 'ui';

const AlertBox = ({ children, onDismiss, wide, styleName, className }) => (
  <RenderInBody>
    <ModalContainer
      className={`AlertBox AlertBox-background ${styleName || className}`}
      onEscape={onDismiss}
    >
      <div
        className={classNames('AlertBox-container', {
          'AlertBox-container--wide': wide,
        })}
      >
        {children}
        {onDismiss && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <div className="AlertBox-dismissButton" onClick={onDismiss}>
            <Icon name="error" />
          </div>
        )}
      </div>
    </ModalContainer>
  </RenderInBody>
);

export const Heading = ({ children }) => (
  <div className="AlertBox-heading">{children}</div>
);

export const SubHeading = ({ children }) => (
  <div className="AlertBox-subheading">{children}</div>
);

export default AlertBox;
